import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import Layout from "template";
import { MenuItems } from "template/MenuItems";
import { UpmandalBasthiReportCard } from "./UpmandalBasthiCard";
import { UpmandalSthayiReportCard } from "./UpaMandalSthayiReport"
import { Link } from "react-router-dom";
import { APIService } from "services";
import {
  useParams
} from "react-router-dom";


export const UpmandalBasthiReports: React.FC = () => {
  const [UpmandalCount, setUpmandalCount] = useState([])
  const [upamandalSthayiCount, setUpamandalSthayiCount] = useState([])
  const [gramamSthayiCount, setGramamSthayiCount] = useState([])

  const [gramamData, setGramamData] = useState([]);

  const { id } = useParams();
  let nagar_khandaId = localStorage.setItem("nagar_khanda_id", id)
  let jilla_id = localStorage.getItem("jilla_id")
  // console.log("nagar_khandaId",nagar_khandaId)
  let nagarTypes = localStorage.getItem('nagar_type')
  let vibhag_id = localStorage.getItem("vibhag_id")
  // console.log("23 vibhag_id in upamandal page",vibhag_id)
  // console.log("24 jilla_id in upamandal page",jilla_id)
  const [isLoading, setIsLoading] = React.useState(false);
  useEffect(() => {
    // console.log("15id",type_id)
    console.log("18nagarTypesinUpmandal", nagarTypes)
    let payload;
    if (nagarTypes === "2") {
      payload = {
        type: "nagar",
        type_id: id,
      };
    } else if (nagarTypes === "1") {
      payload = {
        type: "khanda",
        type_id: id,
      };
    }
    else {
      payload = {
        type: "nagar_khanda",
        type_id: id,
      };
    }
    setIsLoading(true)
    APIService.api().post("https://lhac.lokahitam.net/api/v1/samithi_members/searchWithFields", payload).then((response) => {
      console.log("44responseupamandalscreen", response)
      let vibhagData = response.data.SamithiReport
      let gramamCount = response.data.gramamSamithiReport
      setGramamData(gramamCount);
      setUpmandalCount(vibhagData)
      // setUpamandalSthayiCount(array)
      let array = []
      array.push(response.data.SamithiReport[0])
      if (array && array.length > 0) {
        const filteredArray = array.filter(item => item !== undefined);
        setIsLoading(false)
        setUpamandalSthayiCount(filteredArray)
      }
      let gramamArray = []
      gramamArray.push(response.data.gramamSamithiReport[1])
      if (gramamArray && gramamArray.length > 0) {
        const filteredArray = gramamArray.filter(item => item !== undefined);
        setGramamSthayiCount(filteredArray)
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [1000]);
  let MemberName = localStorage.getItem('member_name')
  let vibhagName = localStorage.getItem('vibhag_name')
  let jillaName = localStorage.getItem('zilla_name')
  let nagarKhandaName = localStorage.getItem('nagar_khanda_name')

  console.log("73upamandalSthayiCount", upamandalSthayiCount)
  console.log("74gramamSthayiCount", gramamSthayiCount)
  // console.log("46jillaName",gramamData)
  let DesignationId = parseInt(localStorage.getItem("desig_level_id"))
  console.log("83DesignationId", DesignationId)
  console.log("84jillaName", jillaName)

  // let jilla_id=localStorage.getItem("jilla_id")
  // console.log("210nagar_khandaId",nagar_khandaId)
  // let vibhag_id=localStorage.getItem("vibhag_id")
  let upamandal_basthi_id = localStorage.getItem("upamandal_basthi_id")
  // let nagarKhandaName=localStorage.getItem('nagar_khanda_name')
  let upMandalName = localStorage.getItem('upamandal_name')
  let gramamName = localStorage.getItem('gramam_name')
  // console.log("44upMandalNamegramamspage",upMandalName)
  let bastiName = localStorage.getItem('basti_name')
  // let nagar_khandaId=localStorage.getItem('nagar_khanda_id')
  return (
    <Layout>
      <div className="container-fluid" >
        <div className="d-sm-flex align-items-center justify-content-between mb-4" >
          {/* <h1 className="h3 mb-0 text-gray-800" > Upmandal/Basthi  </h1> */}
        </div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb" >
            {(DesignationId === 1 || DesignationId === 2) &&
              <li className="breadcrumb-item" ><Link to="/vibhagreports" style={{ color: "#194380" }}>{vibhagName}</Link></li>
            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3) &&

              (vibhag_id != "undefined" && vibhag_id && vibhag_id != "null") &&
              <li className="breadcrumb-item" ><Link to={'/jillareports/' + vibhag_id} style={{ color: "#194380" }}>{jillaName}</Link></li>


            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3 || DesignationId === 4) &&
              <li className="breadcrumb-item"><Link to={'/nagarkhandareports/' + jilla_id} style={{ color: "#194380" }}>{nagarKhandaName}</Link></li>
            }

          </ol>
        </nav>
        <div className="h5 mb-0 font-weight-bold text-gray-800">
          <p>Namasthe,  {MemberName} 🙏</p></div>
        <div className="d-flex flex-column min-vh-100" >
          {/* UpmandalSthayiReportCard */}
          <Row>
            {upamandalSthayiCount && upamandalSthayiCount.map((item, i) => {
              return <UpmandalSthayiReportCard key={`Card-${i}`} id={item.id} total_gramas_count={item.total_gramas_count} total_gramas_formed={item.total_gramas_formed} total_basti_count={item.total_basti_count} total_samithi_formed={item.total_samithi_formed} basti_name={item.basti_name} nagar_type={item.nagar_type} upamandal_name={item.upamandal_name} gramams_formed={item.gramams_formed} basti_gramam_type={item.basti_gramam_type} members_registered={item.members_registered} total_basti={item.total_basti} total_gramas={item.total_gramas} />
            })}
            {gramamSthayiCount && gramamSthayiCount.map((item, i) => {
              if (item.id != "undefined") {
                return <UpmandalSthayiReportCard key={`Card-${i}`} id={item.id} total_gramas_count={item.total_gramas_count} total_basti_count={item.total_basti_count} total_samithi_formed={item.total_samithi_formed} total_gramas_formed={item.total_gramas_formed} basti_name={item.basti_name} nagar_type={item.nagar_type} upamandal_name={item.upamandal_name} gramams_formed={item.gramams_formed} basti_gramam_type={item.basti_gramam_type} members_registered={item.members_registered} total_basti={item.total_basti} total_gramas={item.total_gramas} />
              }
            })}
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center" style={{ marginTop: "230px" }}>
              <div className="spinner-border" role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
          ) :
            <Row>
              {UpmandalCount.map((item, i) => {
                return <UpmandalBasthiReportCard key={`Card-${i}`} id={item.id} basti_name={item.basti_name} nagar_type={item.nagar_type} upamandal_name={item.upamandal_name} gramams_formed={item.gramams_formed} basti_gramam_type={item.basti_gramam_type} members_registered={item.members_registered} total_basti={item.total_basti} total_gramas={item.total_gramas} />
              })}
              {gramamData.map((item, i) => {
                return <UpmandalBasthiReportCard key={`Card-${i}`} id={item.id} basti_name={item.basti_name} nagar_type={item.nagar_type} upamandal_name={item.upamandal_name} gramams_formed={item.gramams_formed} basti_gramam_type={item.basti_gramam_type} members_registered={item.members_registered} total_basti={item.total_basti} total_gramas={item.total_gramas} />
              })}
            </Row>
          }
        </div>
      </div></Layout >
  );
};

